function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#logout_svg__clip0)",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.5 10.834a.833.833 0 00-.833.833V15c0 .46-.374.834-.834.834h-2.5v-12.5A1.68 1.68 0 007.198 1.75l-.246-.083h3.881c.46 0 .834.374.834.833V5a.833.833 0 101.666 0V2.5c0-1.378-1.122-2.5-2.5-2.5H1.875c-.032 0-.058.015-.09.019C1.746.015 1.708 0 1.668 0 .747 0 0 .748 0 1.667v15a1.68 1.68 0 001.135 1.584l5.015 1.672c.17.052.339.077.517.077.919 0 1.666-.747 1.666-1.666V17.5h2.5c1.378 0 2.5-1.121 2.5-2.5v-3.333a.833.833 0 00-.833-.833z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.756 7.744l-3.334-3.333a.833.833 0 00-1.422.59v2.5h-3.333a.834.834 0 000 1.666H15v2.5a.835.835 0 001.422.59l3.334-3.334a.832.832 0 000-1.179z"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "logout_svg__clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h20v20H0z"
})));

function SvgLogout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgLogout;